module.exports = __webpack_public_path__ + "static/media/A4.e87961e5.jpg";